var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import decode from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import { trackEvent } from "./analytics";
// This is an example custom hook
// The naming syntax is SPECIFICALLY "useSomething" for all hooks
export var useLocalStorage = function (keyName) {
    // We don't want to hammer localStorage continuously forever,
    //  so we use `useState` to store the last value we got from localStorage
    //  kind of like a cache, and we pre-set it to the current value of whatever
    //  localStorage key we're interested in.
    var _a = useState(JSON.parse(window.localStorage.getItem(keyName)) || null), value = _a[0], updateValue = _a[1];
    // This is the function that will be called whenever localStorage updates
    var listener = function (event) {
        // Like most event handlers, this function is given an `event` object
        //  containing a whole load of stuff we don't care about, so we
        //  destructure it to extract just the `key` and `newValue` properties
        //  as these are the only things we care about.
        var key = event.key, newValue = event.newValue;
        // The localStorage event listener fires on every update to every key in
        //  Storage, so we check the event we've been given to see if it was for
        //  the key that this specific hook is looking for, by comparing the
        //  `key` parameter of the event to the `keyName` this hook was told to
        //  subscribe to. If (and only if!) the keys match, then we update our
        //  local state to store the new value.
        if (key == keyName) {
            updateValue(newValue);
        }
    };
    // Because we're binding an event listener to the `window` object, executing
    //  this hook has a long-lasting impact on the state of the browser session.
    //  Therefore this hook would be described as "having side effects" - it
    //  doesn't JUST return data, it also changes the world around it a little
    //  bit. Since all of the code in a custom hook like this runs every time
    //  the hook is called (which is roughly once per render) we need to specify
    //  to (p)React that some code, like binding the event listener, should only
    //  execute once. To do this, we wrap that code in a `useEffect` hook call,
    //  so (p)React can go "ok, this is a side effect, so I'm only going to run
    //  this once."
    useEffect(
    // The first argument to `useEffect` is a function that when called,
    //  will "do the side effect". That might be to set up a repeating
    //  series of requests to an API to regularly pull a user's
    //  notifications, or to monitor future changes to the browser window's
    //  size for the purposes of building responsive layouts etc. Roughly
    //  speaking, anything that you don't want to run every time the
    //  component renders would count as a side effect.
    function () {
        // Here is the side effect itself  binding the event listener. If we
        //  let this run every time the component rendered, we could
        //  potentially end up with hundreds or thousands of event listeners
        //  being bound which can not only cause some very strange bugs but
        //  also memory leaks and performance problems like lag or worse.
        window.addEventListener("storage", listener);
        // When using `useEffect` you can also specify how to undo the side
        //  effects. Sometimes you don't need to - if you're just doing a
        //  fetch or something there is no long-lasting effect to clean up.
        //  But here we need to tell (p)React how to remove the event
        //  listener that we bound earlier. To enable this, when calling
        //  `useEffect` we can return a function, which when called will
        //  clear up after ourselves. In this case, because we bound an
        //  event listener, we use the browser's built-in
        //  `window.removeEventListener` function to unbind our event
        //  listener. By providing (p)React with this function, it will
        //  call it for us when our side effect is no longer needed, thus
        //  ensuring we don't have memory leaks, bugs, performance problems
        //  etc caused by keeping long-lasting stuff like event handlers
        //  alive forever.
        return function () { return window.removeEventListener("storage", listener); };
    }, 
    // The second argument to a `useEffect` function call is an array that
    //  contains all of the variables that should "reset" our side effect.
    //  In this case, if our hook call changes from `useLocalStorage("foo")`
    //  to `useLocalStorage("bar")`, we don't need to do anything because
    //  our side effect listens to *all* of localStorage, so we don't need
    //  to unbind it, and replace it with a new one. But you can imagine if
    //  our side effect could only detect changes to one specific key, we'd
    //  need to unbind it so we stop seeing update to "foo" and re-bind with
    //  a new listener that listens for changes to "bar". But because we
    //  don't need to do that here, we can give `useEffect` an empty array.
    //  You can think of this as basically saying explicitly "even if your
    //  inputs change, you don't need to clear the side effect and re-run"
    []);
    // Just a small function that we can give back to the code that's calling
    //  our hook, to let it write new data *into* the localStorage key as well
    //  as just reading from it. This effectively makes this hook behave a lot
    //  like `useState` except that the data is persistently stored in
    //  localStorage.
    var setValue = function (newValue) {
        updateValue(newValue);
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
    };
    // Finally, return an array containing the current value from the key we're
    //  watching in localStorage, and a function that the caller can use to
    //  put new data into that key.
    return [value, setValue];
};
// A much smaller, simpler example hook showing how we can easily use hooks
//  inside other hooks. This one is a less-generic case, a hook we can use to
//  only read from (but not write to!) the "user" key in localStorage.
export var useUser = function () {
    // `useLocalStorage` returns an array as described above, but we don't care
    //  about the second item in the array, which is the function we'd use to
    //  save a new value into localStorage. So we destructure the return from
    //  `useLocalStorage` to keep just the current value, which we know will be
    //  the JWT, and return that.
    var jwt = useLocalStorage("user")[0];
    return jwt === null ? {} : decode(jwt);
};
// An example of squashing the `useUser` hook down even smaller. I wouldn't
//  recommend actually doing this, but it does sort of show how easy it can
//  be to make hooks out of other hooks
export var useUserCompact = function () { return useLocalStorage("user")[0]; };
export var useAnalytics = function (packet) {
    useEffect(function () {
        trackEvent(packet);
    }, [packet]);
};
export var useHeartbeats = function (packet, frequency) {
    useEffect(function () {
        trackEvent(packet);
        var intervalID = setInterval(function () { return trackEvent(packet); }, frequency);
        return function () { return clearInterval(intervalID); };
    }, [packet, frequency]);
};
export var useInterval = function (callback, delay) {
    if (delay === void 0) { delay = 1000; }
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var savedCallback = useRef();
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current.apply(savedCallback, args);
            }
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [callback.toString(), delay]);
};
export var useJitsi = function (options, domain, meetingConfig) {
    if (domain === void 0) { domain = "meet.jit.si"; }
    if (meetingConfig === void 0) { meetingConfig = { allowComunication: true, onDisconnect: function () { } }; }
    var _a = useState(false), isAPILoaded = _a[0], setIsAPILoaded = _a[1];
    var jitsiAPIRef = useRef(null);
    var comunicationConfig = [
        'microphone',
        'camera',
        'raisehand',
        'mute-everyone',
        'mute-video-everyone',
        'shareaudio',
        'sharedvideo',
        'desktop',
        'toggle-camera',
    ];
    // Add the Jitsi external script to the page
    useEffect(function () {
        var jitsiScript = document.createElement("script");
        jitsiScript.setAttribute("src", "https://8x8.vc/external_api.js");
        jitsiScript.setAttribute("id", "jitsiScript");
        document.head.appendChild(jitsiScript);
        // Clean up after ourselves by removing the Jitsi script
        return function () { var _a; return (_a = document.getElementById("jitsiScript")) === null || _a === void 0 ? void 0 : _a.remove(); };
    }, []);
    // Once the Jitsi script has loaded, set a flag so we know we can use it
    useEffect(function () {
        var apiCheckInterval = setInterval(function () {
            if (window.JitsiMeetExternalAPI != undefined) {
                setIsAPILoaded(true);
                clearInterval(apiCheckInterval);
            }
        }, 100);
        // Clean up after ourselves by clearing the interval
        return function () { return clearInterval(apiCheckInterval); };
    }, []);
    // Connect to the call
    useEffect(function () {
        if (isAPILoaded && options.jwt !== "") {
            if (jitsiAPIRef.current) {
                jitsiAPIRef.current.dispose();
            }
            if (options.roomName === null) {
                jitsiAPIRef.current = null;
            }
            else {
                var jitsiAPI_1 = new window.JitsiMeetExternalAPI(domain, __assign(__assign({}, options), { configOverwrite: {
                        remoteVideoMenu: {
                            disableKick: !meetingConfig.allowComunication,
                        },
                        startWithAudioMuted: !meetingConfig.allowComunication,
                        disableInviteFunctions: true,
                        disableRemoteMute: !meetingConfig.allowComunication,
                        toolbarButtons: __spreadArray(__spreadArray([], [
                            'closedcaptions',
                            'chat',
                            'download',
                            'embedmeeting',
                            'etherpad',
                            'feedback',
                            'filmstrip',
                            'fullscreen',
                            'hangup',
                            'help',
                            'participants-pane',
                            'profile',
                            'recording',
                            'select-background',
                            'settings',
                            'shortcuts',
                            'tileview',
                            '__end'
                        ], false), (meetingConfig.allowComunication ? comunicationConfig : []), true),
                    } }));
                jitsiAPI_1.addListener("readyToClose", function () {
                    if (typeof meetingConfig.onDisconnect === "function")
                        meetingConfig.onDisconnect();
                    return jitsiAPI_1.dispose();
                });
                jitsiAPIRef.current = jitsiAPI_1;
            }
        }
        // Clean up after ourselves by disconnecting from the call
        return function () {
            if (jitsiAPIRef.current) {
                jitsiAPIRef.current.dispose();
            }
            jitsiAPIRef.current = null;
        };
    }, [
        isAPILoaded,
        domain,
        JSON.stringify(options),
    ]);
};
export var useDateTime = function (resolution) {
    if (resolution === void 0) { resolution = "minute"; }
    var _a = useState(new Date()), time = _a[0], updateTime = _a[1];
    var timeout = resolution === "day" ? 86400000
        : resolution === "hour" ? 3600000
            : resolution === "minute" ? 60000
                : 1000; // 1 second
    useEffect(function () {
        window.setInterval(function () { return updateTime(new Date()); }, timeout);
    }, [resolution]);
    return time;
};
export var useDataApi = function (initialUrl, initialData) {
    var _a = useState(initialData), data = _a[0], setData = _a[1];
    var _b = useState(initialUrl), url = _b[0], setUrl = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(false), isError = _d[0], setIsError = _d[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsError(false);
                        setIsLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        result = _b.sent();
                        _a = setData;
                        return [4 /*yield*/, result.json()];
                    case 3:
                        _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.log(error_1);
                        setIsError(true);
                        return [3 /*break*/, 5];
                    case 5:
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [url]);
    return [data, isLoading, isError];
};
export var sendData = function (initialUrl, request, initialData) {
    var _a = useState(initialData), data = _a[0], setData = _a[1];
    var _b = useState(initialUrl), url = _b[0], setUrl = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(false), isError = _d[0], setIsError = _d[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsError(false);
                        setIsLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(request)
                            })];
                    case 2:
                        result = _b.sent();
                        if (!(initialData == null)) return [3 /*break*/, 3];
                        setData(null);
                        return [3 /*break*/, 5];
                    case 3:
                        _a = setData;
                        return [4 /*yield*/, result.json()];
                    case 4:
                        _a.apply(void 0, [_b.sent()]);
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        setIsError(true);
                        return [3 /*break*/, 7];
                    case 7:
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [url, initialData]);
    return [data, isLoading, isError];
};
//# sourceMappingURL=hooks.js.map